import React from "react";
import BlogCard from "./HomeBlog/BlogCard";
import BlogHeader from "./BlogHeader";
import ShowAllButton from "./HomeFeatured/ShowAllButton";

const HomeBlog = ({ data: blogData }) => {
  const blogs = blogData.data;
  const page = blogData.page;
  return (
    <div className="lg:pt-[102px] md:pt-12 pt-6 lg:pb-[104px] md:pb-12 pb-6">
      <div className="container">
        <BlogHeader page={page} />
        <div className="flex grid-cols-3 gap-3 pb-2 mb-4 overflow-x-auto xl:grid flex-nowrap lg:pb-0 sm:mb-0">
          {blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>
        <ShowAllButton url={page.url} title={page.title} styles="inline-flex sm:hidden" />
      </div>
    </div>
  );
};

export default HomeBlog;
